import { useEffect } from "react";
import { HiOutlinePlus } from "react-icons/hi";
import { LuTrash } from 'react-icons/lu';


export const CommunicationPartner = ({ communicationPartner, setCommunicationPartner, setPartnerValid }) => {

    const increaseCommunicationPartner = () => {
        setCommunicationPartner([...communicationPartner, {
            name: '',
            department: '',
            phone: '',
            email: '',
        }])
    }

    const decreaseCommunicationPartner = (index) => {
        if (communicationPartner.length === 1) {
            return;
        }
        setCommunicationPartner(communicationPartner.filter((partner, i) => i !== index))
    }

    useEffect(() => {
        const validateCommunicationPartner = () => {
            // if all fields in every partner are empty, return true
            const noPartner = communicationPartner.every(partner => {
                return (partner.name === '' && partner.department === '' && partner.phone === '' && partner.email === '') || (partner.name.length >= 1 && partner.department.length >= 1 && partner.phone.length >= 1 && partner.email.length >= 1);
            });
            if (noPartner) {
                setPartnerValid(true);
                return;
            }
            setPartnerValid(false);
        }

        validateCommunicationPartner();
    }, [communicationPartner, setPartnerValid])


    return (
        <div >
            <h4 className="font-semibold mt-8 text-xl  text-gray-900 ">
               Sonstige Ansprechparnter erfassen
            </h4>
            <p className={"mb-8 text-gray-600/60 my-4 "}>Gibt es neben Ihnen noch weitere Ansprechpartner für Rückfragen (z.B. Kollegen, Ansprechpartner im Bauamt)?</p>

            {communicationPartner.map((partner, index) => (
                <div key={index} className={"pt-6 mb-8 relative"}>
                    <div className={"left-0 -top-4 absolute bg-white p-2 flex pl-0 text-gray-600 font-bold "}>
                        {`Ansprechpartner ${index + 1}`}
                        {index !== 0 && index === communicationPartner.length -1 && (<LuTrash className="w-6 h-6 -mt-1 p-1 ml-2 cursor-pointer " onClick={ () => decreaseCommunicationPartner(index)} />)}
                    </div>

                    <div>
                        <div className={"relative mb-2 w-full "}>
                            <span className={"text-xs text-gray-600/60 z-0 pt-2.5 pl-2 absolute"}>Vor- & Zuname</span>
                            <input 
                                type={"text"} 
                                className={"border-gray-500 z-1 text-sm w-full rounded pl-[100px]"}
                                value={communicationPartner[index].name}
                                onChange={(e) => {
                                    const newCommunicationPartner = [...communicationPartner];
                                    newCommunicationPartner[index].name = e.target.value;
                                    setCommunicationPartner(newCommunicationPartner);
                                }}
                            />
                        </div>
                        <div className={"relative mb-2 w-full "}>
                            <span className={"text-xs text-gray-600/60 z-0 pt-2.5 pl-2 absolute"}>Abteilung</span>
                            <input  
                                type={"text"} 
                                className={"border-gray-500 z-1 text-sm w-full rounded pl-[100px]"}
                                value={communicationPartner[index].department}
                                onChange={(e) => {
                                    const newCommunicationPartner = [...communicationPartner];
                                    newCommunicationPartner[index].department = e.target.value;
                                    setCommunicationPartner(newCommunicationPartner);
                                }}
                            />
                        </div>
                        <div className={"flex gap-2"}>
                            <div className={"relative  w-1/2 "}>
                                <span className={"text-xs text-gray-600/60 z-0 pt-2.5 pl-2 absolute"}>Telefon</span>
                                <input 
                                    type={"text"} 
                                    className={"border-gray-500 z-1 text-sm w-full rounded pl-[100px]"}
                                    value={communicationPartner[index].phone}
                                    onChange={(e) => {
                                        const newCommunicationPartner = [...communicationPartner];
                                        newCommunicationPartner[index].phone = e.target.value;
                                        setCommunicationPartner(newCommunicationPartner);
                                    }}
                                />
                            </div>
                            <div className={"relative  w-1/2 "}>
                                <span className={"text-xs text-gray-600/60 z-0 pt-2.5 pl-2 absolute"}>E-Mail</span>
                                <input 
                                    type={"email"} 
                                    value={communicationPartner[index].email}
                                    className={"border-gray-500 z-1 text-sm w-full rounded pl-[100px]"}
                                    onChange={(e) => {
                                        const newCommunicationPartner = [...communicationPartner];
                                        newCommunicationPartner[index].email = e.target.value;
                                        setCommunicationPartner(newCommunicationPartner);
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            ))}
            <div className="flex cursor-pointer text-gray-600/60 text-sm">
                    <span className={"border border-gray-500 rounded p-2"} onClick={increaseCommunicationPartner} > + Weitere hinterlegen</span>
            </div>
        </div>
    )
}